var _circle, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZh({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u5716\\u5C64_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "311.81px",
    height: "311.81px",
    viewBox: "0 0 311.81 311.81",
    enableBackground: "new 0 0 311.81 311.81",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#DC2E27",
    stroke: "#000000",
    strokeMiterlimit: 10,
    cx: 157,
    cy: 157,
    r: 150
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path3374_1_",
    fill: "#F7DC15",
    d: "M191.928,83.868l7.479,12.46l-9.544,10.964l14.164-3.26l7.478,12.459l1.279-14.476 l14.159-3.26l-13.371-5.685l1.271-14.479l-9.538,10.964L191.928,83.868z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "path3433_1_",
    fill: "#F7DC15",
    d: "M107.009,97l-13.46,41.46H49.94l35.271,25.628L71.743,205.54l35.276-25.616l35.265,25.612 l-13.473-41.444l35.264-25.64l-43.6,0.012L107.009,97z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "path3447_1_",
    fill: "#F7DC15",
    d: "M238.217,119.048l2.061,14.38l-13.047,6.399l14.314,2.492L243.6,156.7l6.797-12.844 l14.313,2.488l-10.12-10.424l6.788-12.848l-13.045,6.404L238.217,119.048z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "path3453_1_",
    fill: "#F7DC15",
    d: "M214.076,218.288L205,229.636l-13.6-5.128l7.982,12.141l-9.074,11.344l14.012-3.84 l7.984,12.132l0.672-14.507l14.012-3.85l-13.586-5.123L214.076,218.288z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "path3475_1_",
    fill: "#F7DC15",
    d: "M246.305,177.012l-3.99,13.973l-14.527,0.521l12.057,8.116l-3.99,13.968l11.442-8.956 l12.054,8.108l-4.984-13.644l11.439-8.965l-14.523,0.524L246.305,177.012z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZh);
export default __webpack_public_path__ + "static/media/zh.10baaf49e5ed5e7657c2e9ee2a1fcfdf.svg";
export { ForwardRef as ReactComponent };